import { TypeExtends } from "sb-js-extends";
import { BonusMessageType } from "../../../../types";
import { getDictPhrase } from "../../../common";
TypeExtends();
export const getBonusDetailsFreeBet = (freeBetInfo, state) => {
    const message = freeBetInfo.isRiskFreeBet
        ? getDictPhrase(state.dict, "RiskFreeBetMessage")
        : getDictPhrase(state.dict, "FreeBetMessage");
    return {
        type: BonusMessageType.FreeBet,
        phrase: message.format(state.formatCurrency(freeBetInfo.freeBetAmount))
    };
};
//# sourceMappingURL=getBonusDetailsFreeBet.js.map